module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "padded"
  }, [_c('el-collapse', {
    attrs: {
      "accordion": ""
    },
    model: {
      value: (_vm.activeTab),
      callback: function($$v) {
        _vm.activeTab = $$v
      },
      expression: "activeTab"
    }
  }, [_c('el-collapse-item', {
    attrs: {
      "name": "summary"
    }
  }, [_c('template', {
    slot: "title"
  }, [_vm._v("\n           Summary "), _c('i', {
    staticClass: "header-icon fa fa-info-circle"
  })]), _vm._v(" "), (_vm.showGraph) ? _c('property-charts') : _vm._e()], 2), _vm._v(" "), _c('el-collapse-item', {
    attrs: {
      "name": "rental"
    }
  }, [_c('template', {
    slot: "title"
  }, [_vm._v("\n          Rental by Month "), _c('i', {
    staticClass: "header-icon fa fa-money"
  })]), _vm._v(" "), _c('property-rental-month')], 2), _vm._v(" "), _c('el-collapse-item', {
    attrs: {
      "name": "due"
    }
  }, [_c('template', {
    slot: "title"
  }, [_vm._v("\n          Rental Due "), _c('i', {
    staticClass: "header-icon fa fa-clock"
  })]), _vm._v(" "), _c('tenancy-due')], 2), _vm._v(" "), _c('el-collapse-item', {
    attrs: {
      "name": "expiry"
    }
  }, [_c('template', {
    slot: "title"
  }, [_vm._v("\n          Expiring Tenancies "), _c('i', {
    staticClass: "header-icon fa fa-business-time"
  })]), _vm._v(" "), _c('property-expiry')], 2), _vm._v(" "), _c('el-collapse-item', {
    attrs: {
      "name": "landlords",
      "label": "Landlords"
    }
  }, [_c('template', {
    slot: "title"
  }, [_vm._v("\n          Landlords "), _c('i', {
    staticClass: "header-icon fa fa-home"
  })]), _vm._v(" "), _c('property-landlords')], 2)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-295432d6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/property/PropertyDashboard.vue
// module id = 1387
// module chunks = 0